import React from "react";
import {connect, MapStateToProps} from 'react-redux';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import {DeleteIcon} from '../../../../elements/svgIcons'

interface OwnProps {
    removeAvatar: () => void;
}

interface ConnectStateProps {
    User: any;
}

type Props = OwnProps & ConnectStateProps

const AvatarEditTooltip = (props: Props) => {
    const user = props.User;
    return (
        <div className='buttons-wrapper'>
            <label className='mb-0' htmlFor="avatar-upload">
                <div className='btn btn-add'>
                    <AddCircleOutlineIcon className='circle-icon'/>Add Image
                </div>
            </label>
            {user.avatar &&
            <div onClick={() => props.removeAvatar()} className='btn btn-remove mt-2'>
                <DeleteIcon className='delete-icon'/>Remove Image
            </div>}
        </div>
    )
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {User} = state;
    return {
        User
    }
};

export default connect(mapStateToProps)(AvatarEditTooltip)
